module.exports = __webpack_public_path__ + "static/media/scroll.4440c0f5.svg";